import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { api } from '../api'

export type User = { must_change_password?: boolean; id: number; username: string; real_name: string; role: 'admin' | 'editor' | 'viewer' | 'operator' | 'shop_ops' }

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('xhs_v2_token') || '')
  const stored = localStorage.getItem('xhs_v2_user')
  let restored: User | null = null
  try {
    const value = stored ? JSON.parse(stored) : null
    if (value && typeof value.username === 'string' && ['admin', 'editor', 'viewer', 'operator', 'shop_ops'].includes(value.role)) restored = value
  } catch { /* A damaged browser cache should lead to login, not a blank page. */ }
  const user = ref<User | null>(restored)
  const loggedIn = computed(() => Boolean(token.value && user.value))

  async function login(username: string, password: string) {
    const data = await api.post<any, { token: string; user: User }>('/auth/login', { username, password })
    token.value = data.token; user.value = data.user
    localStorage.setItem('xhs_v2_token', token.value)
    localStorage.setItem('xhs_v2_user', JSON.stringify(user.value))
  }
  async function refreshUser() {
    const data = await api.get<any, User>('/auth/me')
    user.value = data
    localStorage.setItem('xhs_v2_user', JSON.stringify(data))
  }
  async function logout() {
    try { await api.post('/auth/logout') } catch { /* Local logout must still complete if offline. */ }
    clearSession()
  }
  function clearSession() {
    token.value = ''; user.value = null
    localStorage.removeItem('xhs_v2_token'); localStorage.removeItem('xhs_v2_user')
  }
  return { token, user, loggedIn, login, logout, clearSession, refreshUser }
})
